import React,{ useState, useEffect, useContext , useRef } from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import ConfirmationDialogRaw from '../components/ConfirmationDialogRaw';
import {
  Grid,
  Typography,
  Modal,
  Button,
  FormControlLabel,
  FormControl,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core';
import { FirebaseContext } from 'common';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CancelIcon from '@material-ui/icons/Cancel';
import PaymentIcon from '@material-ui/icons/Payment';
import UsersCombo from '../components/UsersCombo';
import { makeStyles } from '@material-ui/core/styles';
import { useTranslation } from "react-i18next";
import moment from 'moment/min/moment-with-locales';

import Table from '../components/Table';

const useStyles = makeStyles((theme) => ({
  // title:

  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 680,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const icons = {
  'paypal':require('../assets/img/payment-icons/paypal-logo.png').default,
  'braintree':require('../assets/img/payment-icons/braintree-logo.png').default,
  'stripe':require('../assets/img/payment-icons/stripe-logo.png').default,
  'paytm':require('../assets/img/payment-icons/paytm-logo.png').default,
  'payulatam':require('../assets/img/payment-icons/payulatam-logo.png').default,
  'flutterwave':require('../assets/img/payment-icons/flutterwave-logo.png').default,
  'paystack':require('../assets/img/payment-icons/paystack-logo.png').default,
  'securepay':require('../assets/img/payment-icons/securepay-logo.png').default,
  'payfast':require('../assets/img/payment-icons/payfast-logo.png').default,
  'liqpay':require('../assets/img/payment-icons/liqpay-logo.png').default,
  'culqi':require('../assets/img/payment-icons/culqi-logo.png').default,
  'mercadopago':require('../assets/img/payment-icons/mercadopago-logo.png').default
}

const BookingHistory = (props) => {
  const { api, appcat } = useContext(FirebaseContext);
  const { t } = useTranslation();
  const {
    cancelBooking,
    updateBooking,
    RequestPushMsg
  } = api;
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const userdata = useSelector(state => state.usersdata);
  const settings = useSelector(state => state.settingsdata.settings);
  const [role, setRole] = useState(null);
  const [paymentModalStatus, setPaymentModalStatus] = useState(false);
  const providers = useSelector(state => state.paymentmethods.providers);
  const [selectedProvider, setSelectedProvider] = useState();
  const [selectedProviderIndex, setSelectedProviderIndex] = useState(0);
  const [data, setData] = useState([]);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState();
  const bookinglistdata = useSelector(state => state.bookinglistdata);
  const [users, setUsers] = useState(null);
  const [userCombo, setUserCombo] = useState(null);
  const rootRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [rowIndex, setRowIndex] = useState();

  const classes = useStyles();

  const columns =  [
    { headerName: 'ID', field: 'id', sortable: false, hide: true },
    { headerName: 'Date', field: 'tripdate', width: 175, renderCell: ({ value }) => value ? moment(value).format('lll') : null },
    { headerName: 'Driver Name', field: 'carType', sortable: false }, //todo: fix this
    { headerName: 'Rider Name', field: 'customer_name' },
    { headerName: 'Pickup', field: 'pickupAddress', sortable: false },
    { headerName: 'Drop', field: 'dropAddress', sortable: false },
    { headerName: 'Driver', field: 'driver_name' },
    { headerName: 'Delivery Person', field: 'deliveryPerson', hide: appcat === 'taxi' },
    { headerName: 'D.P. Phone', field: 'deliveryPersonPhone', hide: appcat === 'taxi' },
    { headerName: 'Pickup Inst.', field: 'pickUpInstructions', hide: appcat === 'taxi' },
    { headerName: 'Deliver Inst.', field: 'deliveryInstructions', hide: appcat === 'taxi' },
    // { headerName: 'Parcel Type', field: 'parcel_type', renderCell: parcelTypeSelected => parcelTypeSelected ? `${parcelTypeSelected.description} (${parcelTypeSelected.amount})`: '' , hidden: appcat === 'taxi' },
    // { headerName: 'Parcel Opt.', field: 'parcel_option', renderCell: optionSelected => optionSelected ? `${optionSelected.description} (${optionSelected.amount})`: '' , hidden: appcat === 'taxi' },
    { headerName: 'Status', field: 'status' },
    { headerName: 'Pickup Img', field: 'pickup_image', renderCell: data => data.value ? <img alt='Pick Up' src={data.value} style={{width: 150}}/> : 'N/A', editable: false, hide: appcat === 'taxi' },
    { headerName: 'Driver Img', field: 'deliver_image', renderCell: data => data.value ? <img alt='Deliver' src={data.value} style={{width: 150}}/> : 'N/A', editable: false, hide: appcat === 'taxi' },
    { headerName: 'Cancel Reason', field: 'reason', width: 250 },
    { headerName: 'Passcode', field: 'otp' },
    { headerName: 'CO2 Saved', field: 'trip_cost' },
    { headerName: 'Trip Start', field: 'trip_start_time' },
    { headerName: 'Trip End', field: 'trip_end_time' },
    { headerName: 'Total Time', field: 'total_trip_time' },
    { headerName: 'Distance', field: 'distance' },
    { headerName: 'Vehicle Tag', field: 'vehicle_number' },  
    { headerName: 'Points Earned', field: 'driver_share' },
    // { headerName: 'Conv. Fee', field: 'convenience_fees' },
    // { headerName: 'Discount', field: 'discount' },      
    // { headerName: 'Customer Paid', field: 'customer_paid', width: 175 },
    // { headerName: 'Pay Mode', field: 'payment_mode' },
    // { headerName: 'Pay Gateway', field: 'gateway' },
    // { headerName: 'Cash Paid', field: 'cashPaymentAmount' },
    // { headerName: 'Card Paid', field: 'cardPaymentAmount' },
    // { headerName: 'Wallet Paid', field: 'usedWalletMoney' }
];

  useEffect(()=>{
    if(bookinglistdata.bookings){
        setData(bookinglistdata.bookings);
    }else{
      setData([]);
    }
  },[bookinglistdata.bookings]);

  useEffect(() => {
    if(auth.info && auth.info.profile){
      setRole(auth.info.profile.usertype);
    }
  }, [auth.info]);

  useEffect(() => {
    if (userdata.users) {
      let arr = [];
      for (let i = 0; i < userdata.users.length; i++) {
        let user = userdata.users[i];
        if (user.usertype === 'driver') {
          arr.push({
            'firstName': user.firstName,
            'lastName': user.lastName,
            'mobile': user.mobile,
            'email': user.email,
            'uid': user.id,
            'desc': user.firstName + ' ' + user.lastName + ' (' + (settings.AllowCriticalEditsAdmin? user.mobile : "Hidden") + ') ' + (settings.AllowCriticalEditsAdmin? user.email : "Hidden"),
            'pushToken': user.pushToken
          });
        }
      }
      setUsers(arr);
    }
  }, [userdata.users,settings.AllowCriticalEditsAdmin]);

  const assignDriver = () => {
    let booking = data[rowIndex];
    if(booking['requestedDrivers']){
      booking['requestedDrivers'][userCombo.uid]=true;
    }else{
      booking['requestedDrivers']={};
      booking['requestedDrivers'][userCombo.uid]=true;
    }
    dispatch(updateBooking(booking));
    RequestPushMsg(userCombo.pushToken, t('notification_title'), t('new_booking_notification'));
    setUserCombo(null);
    handleClose();
    alert("Driver assigned successfully and notified.");
  }

  const onConfirmClose=(value)=>{
    if(value){
      dispatch(cancelBooking({
        reason:value,
        booking:selectedBooking,
        cancelledBy: role
      }));
    }
    setOpenConfirm(false);
  }

  const handleChange = (e) => {
    if(e.target.name === 'selectedProviderIndex'){
      setSelectedProviderIndex(parseInt(e.target.value));
      setSelectedProvider(providers[parseInt(e.target.value)]);
    }
  };

  const handleClose = () => {
    setOpen(false);
  }

  const handlePaymentModalClose = (e) => {
      setTimeout(()=>{
        setPaymentModalStatus(false);
      },1500)
  }

  useEffect(()=>{
    if(providers){
      setSelectedProvider(providers[0]);
    }
  },[providers]);

  const processPayment = (rowData) =>{
    const curBooking = rowData;
    const paymentPacket = { 
      appcat: appcat,
      payment_mode: 'card',
      customer_paid: (parseFloat(curBooking.trip_cost) - parseFloat(curBooking.discount)).toFixed(2),
      cardPaymentAmount:  curBooking.payableAmount?curBooking.payableAmount:curBooking.trip_cost,
      discount: curBooking.discount? curBooking.discount:0,
      usedWalletMoney: curBooking.usedWalletMoney?curBooking.usedWalletMoney:0,
      cashPaymentAmount: 0,
      promo_applied: curBooking.promo_applied?curBooking.promo_applied:false,
      promo_details: curBooking.promo_details?curBooking.promo_details:null,
      payableAmount: curBooking.payableAmount?curBooking.payableAmount:curBooking.trip_cost
    };
    curBooking.paymentPacket = paymentPacket;
    dispatch(updateBooking(curBooking));
    setSelectedBooking(curBooking);
  }
  
  return (
    bookinglistdata.loading ? <CircularLoading/> :
    <div style={{ height: 500, width: '100%' }}> 
    <Table

      title={'Booking History'}
      columns={columns}
      data={data}
      actions={[
        {
          icon: <CancelIcon />,
          onClick: (rowData) => {
            if(settings.AllowCriticalEditsAdmin && (role ==='rider' || role ==='admin')){
              if(rowData.status==='NEW' || rowData.status==='ACCEPTED'){
                setSelectedBooking(rowData);
                setOpenConfirm(true);
              } else {
                setTimeout(()=>{
                  dispatch(cancelBooking({
                    reason: t('cancelled_incomplete_booking'),
                    booking:rowData
                  }));
                },1500);
              }
            } else {
              alert(t('demo_mode'));
            }
          },
          isDisabled: (rowData) => !(rowData.status==='NEW' || rowData.status==='ACCEPTED' || rowData.status==='PAYMENT_PENDING')
        },
        {
          icon: <PersonAddIcon />,
          onClick: (rowData) => {
            setOpen(true)
            setRowIndex(rowData.id);
          },
          isDisabled: (rowData) => !(rowData.status==='NEW' && role==='admin' && settings.autoDispatch===false)
        },
        {
          icon: <PaymentIcon />,
          onClick: (rowData) => {
            processPayment(rowData);
            setPaymentModalStatus(true);
          },
          isDisabled: (rowData) => !(rowData.status==='PENDING' && role==='rider')
        }
      ]}
    />
    {selectedBooking && selectedBooking.status ==='PENDING' && role==='rider'?
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={paymentModalStatus}
        onClose={handlePaymentModalClose}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <Grid container spacing={2} className={classes.paper}>
        {providers && selectedProvider && selectedBooking?
          <form action={selectedProvider.link} method="POST">
            <input type='hidden' name='order_id' value={selectedBooking.id}/>
            <input type='hidden' name='amount' value={selectedBooking.paymentPacket.payableAmount}/>
            <input type='hidden' name='currency' value={settings.code}/>
            <input type='hidden' name='product_name' value={t('bookingPayment')}/>
            <input type='hidden' name='first_name' value={auth.info.profile.firstName}/>
            <input type='hidden' name='last_name' value={auth.info.profile.lastName}/>
            <input type='hidden' name='quantity' value={1}/>
            <input type='hidden' name='cust_id' value={selectedBooking.customer}/>
            <input type='hidden' name='mobile_no' value={selectedBooking.customer_contact}/>
            <input type='hidden' name='email' value={selectedBooking.customer_email}/>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <FormControl component="fieldset">
                <FormLabel component="legend">{t('payment')}</FormLabel>
                <RadioGroup name="selectedProviderIndex" value={selectedProviderIndex} onChange={handleChange}>
                  {providers.map((provider,index) =>
                  <FormControlLabel key={provider.name} value={index} control={<Radio />} label={<img style={{height:24,margin:7}} src={icons[provider.name]} alt={provider.name}/>} /> 
                  )}
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button onClick={handlePaymentModalClose} variant="contained" color="primary">
              {t('cancel')}
            </Button>
            <Button variant="contained" color="primary" type="submit" style={{marginLeft:10}} onClick={handlePaymentModalClose}>
              {t('paynow_button')}
            </Button>
            </Grid>
          </form>
          :null}
        </Grid>
      </Modal>
    :null}
    <ConfirmationDialogRaw
      open={openConfirm}
      onClose={onConfirmClose}
      value={''}
    />
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        onClose={handleClose}
        open={open}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <Grid container spacing={2} >
            <Grid item xs={12}>
              <Typography component="h1" variant="h5" className={classes.title}>
                Select Driver
              </Typography>
            </Grid>
            <Grid item xs={12}>
              {users ?
                <UsersCombo
                  className={classes.items}
                  placeholder={t('select_user')}
                  users={users}
                  value={userCombo}
                  onChange={(event, newValue) => {
                    setUserCombo(newValue);
                  }}
                />
                : null}
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12}>
            <Button onClick={handleClose} variant="contained" color="primary">
              Cancel
            </Button>
            <Button onClick={assignDriver} variant="contained" color="primary" style={{marginLeft:10}}>
              Assign
            </Button>
          </Grid>
          </Grid>
        </div>
      </Modal>
    </div>

  );
}

export default BookingHistory;
